export default "__VITE_ASSET__D1Vd7Pjw__"